import type { FaireProductEntity } from "../../entity_types/product";

export const p_vstts73ex5: FaireProductEntity = {
  token: "p_vstts73ex5",
  type: "product",
  name: "Stars & Stripes Organic Cotton Dress",
  brandToken: "b_np5ktd5ja2",
  brandName: "Burt's Bees Baby",
  imageUrl:
    "https://cdn.faire.com/fastly/8ffeab17476c23e688ab1705da9dc53ae847cdda0df25d5500c4d6ada0a95fa8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/828740742d4178ef338316d4b2f07d7faabe7c5bab3aedc729614acfde38611a.jpeg",
    "https://cdn.faire.com/fastly/15655e3361dc53f5d9f431cabfc861e09efa9f08dad3cbdd1ddc97901d64664a.jpeg",
    "https://cdn.faire.com/fastly/ac6bacb234d6d1afca36c67aa82bd7bd789633dd8a33ad1400d75798926fd2c7.jpeg",
    "https://cdn.faire.com/fastly/5a29b69ffb7744e58295b3663afb9cc2a6af75280823ce61438272d29a5602ab.jpeg",
    "https://cdn.faire.com/fastly/cbc7f655d68379cea2b1e61c66e904bd8b0989786e94615fa81b88d8df12e53e.jpeg",
    "https://cdn.faire.com/fastly/b000b4ccf33233ebbf1c14c7ad3ac57c3f518187216d08a903cf6a2a0a4cbbdf.jpeg",
    "https://cdn.faire.com/fastly/02e766371facbf3608cdd3a9afbaa77844c91dd115ab9b156e7a1faef465d438.jpeg",
  ],
  priceDollars: 14,
  description:
    "From Burt's Bees Baby comes the Stars & Stripes Organic Cotton Dress, a perfect blend of comfort and style for your little one. This dress is not just a piece of clothing, but a testament to our commitment to high-quality, sustainable, and natural products. Crafted from organic cotton, it's designed for utmost comfort and safety. With this dress, your baby's well-being and the planet's future are well taken care of.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:55.127Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
